import React, { useEffect, useState } from "react";
import { convertEnqToMember } from "../../../home/helper/api";
import Toast from "../../../lib/toast";
import { isAuthenticated } from "../../../auth";
import { startLoader, stopLoader } from "../../../lib/utils";

const ConvertToMember = (props) => {

  const {user, token} = isAuthenticated();
  const [isButtonLock, setButtonLock] = useState(false);
  const [enquiryIDs, setSelectedEnquiries] = useState([]);

  const handleEnqConvertToMember = async () => {
    try{
      await startLoader();
      convertEnqToMember(user._id, token, {enquiryIDs}).then(async data => {
        if (data.error) {
          new Toast({
            type:'error',
            duration:3000,
            message:"Error in converting enquiry"
          })
        } else {
          new Toast({
            type:'success',
            duration:3000,
            message:"Enquiry converted to member successfully"
          })
          setSelectedEnquiries([])
          props.handleCloseModal();
          // setBottomActionEnabled(false)
        }
        stopLoader();
      }).catch(err =>{
          console.log(err)
          stopLoader();
      })
      await stopLoader();
    }catch(error){
      await stopLoader()
    }
  }

  useEffect(() => {
    console.log(props)
    if(props.selectedUsers && props.selectedUsers.length > 0){
      const ids = props.selectedUsers.map(item => item._id);
      setSelectedEnquiries(ids);
    }
  },[props])

  return(
    <div onTouchStart={(e)=>e.stopPropagation()} className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`} style={{borderRadius: window.innerWidth < 640 ? "12px 12px 0 0" : ""}}>
      <div className="modal-container flex-item">
        {
          window.innerWidth > 767 && (
            <div className="w-full d-flex space-between" style={{background: "#DEF3FF", padding:"12px", borderRadius: "16px 16px 0 0"}}>
              <div className='d-flex'>
                <svg className='flex-item m-r-8' width="24" height="24" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.077 13.3571H4.92303C4.5966 13.3571 4.28354 13.4851 4.05273 13.7128C3.82191 13.9405 3.69224 14.2494 3.69224 14.5714V15.7857C3.69224 16.1078 3.82191 16.4166 4.05273 16.6443C4.28354 16.8721 4.5966 17 4.92303 17H11.077C11.4034 17 11.7165 16.8721 11.9473 16.6443C12.1781 16.4166 12.3078 16.1078 12.3078 15.7857V14.5714C12.3078 14.2494 12.1781 13.9405 11.9473 13.7128C11.7165 13.4851 11.4034 13.3571 11.077 13.3571ZM11.077 15.7857H4.92303V14.5714H11.077V15.7857ZM15.8198 7.46353L8.43508 0.177765C8.31968 0.0639419 8.16318 0 8 0C7.83682 0 7.68032 0.0639419 7.56492 0.177765L0.18018 7.46353C0.0941415 7.54845 0.035552 7.65662 0.0118177 7.77438C-0.0119165 7.89213 0.000270128 8.01419 0.0468371 8.12512C0.093404 8.23604 0.17226 8.33086 0.273437 8.39757C0.374614 8.46429 0.493569 8.49991 0.615264 8.49994H3.69224V10.9285C3.69224 11.2506 3.82191 11.5594 4.05273 11.7872C4.28354 12.0149 4.5966 12.1428 4.92303 12.1428H11.077C11.4032 12.1423 11.716 12.0143 11.9467 11.7866C12.1774 11.559 12.3073 11.2504 12.3078 10.9285V8.49994H15.3847C15.5064 8.49991 15.6254 8.46429 15.7266 8.39757C15.8277 8.33086 15.9066 8.23604 15.9532 8.12512C15.9997 8.01419 16.0119 7.89213 15.9882 7.77438C15.9644 7.65662 15.9059 7.54845 15.8198 7.46353ZM11.077 7.28564V10.9285H4.92303V7.28564H2.10083L8 1.46552L13.8992 7.28564H11.077Z" fill="var(--darkBlue)"/>
                </svg>
                <p className="flex-item modal-header-text">Convert To Member</p>
              </div>
              <div onClick={props.handleCloseModal} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div>
            </div>
          )
        }
        <div className={`${window.innerWidth < 640 && "m-t-8"} w-full`} style={{height: window.innerWidth > 767 ? "82%" : "100%"}}>
          <div onClick={e => e.stopPropagation()} className="global-modal-scroll-container" style={{ padding: window.innerWidth > 767 ? "0 12px" : "12px" }}>
            <div className="flex-item d-flex">
              <p className="flex-item font-weight-600 m-r-12 fs-16">Selected User(s)</p>
              <div className="items-count-container bg-dark-blue">
                <p className="color-white font-weight-700">{props.selectedUsers.length}</p>
              </div>
            </div>
            <div className="selected-enq-user-list-scroll-container slideTopToBottom m-t-12 bg-white" style={{maxHeight:"95%"}}>
              {
                props.selectedUsers.map((data, index) => {
                  return[
                    <div className="d-flex w-full space-between">
                      <div className="d-flex">
                        <div className="table-item-profile d-flex flex-item">
                          <img className="flex-item" src={'https://picsum.photos/id/1/200/300'} />
                        </div>
                        <div className="flex-item m-l-8">
                          <p className="color-black fs-16 font-weight-600" style={{lineHeight:"16px"}}>{data.userInfo.full_name}</p>
                          <p className="color-grey-02 fs-10 m-t-6" style={{lineHeight:"10px"}}>{data.userInfo.phone}</p>
                        </div>
                      </div>
                      <svg className="flex-item" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.62186 20.5C7.17386 20.5 6.79253 20.3426 6.47786 20.028C6.16319 19.7133 6.00586 19.3323 6.00586 18.885V6.49998H5.00586V5.49998H9.00586V4.72998H15.0059V5.49998H19.0059V6.49998H18.0059V18.885C18.0059 19.345 17.8519 19.7293 17.5439 20.038C17.2359 20.3466 16.8512 20.5006 16.3899 20.5H7.62186ZM17.0059 6.49998H7.00586V18.885C7.00586 19.0643 7.06353 19.2116 7.17886 19.327C7.29419 19.4423 7.44186 19.5 7.62186 19.5H16.3909C16.5442 19.5 16.6852 19.436 16.8139 19.308C16.9425 19.18 17.0065 19.0386 17.0059 18.884V6.49998ZM9.81386 17.5H10.8139V8.49998H9.81386V17.5ZM13.1979 17.5H14.1979V8.49998H13.1979V17.5Z" fill="#FF8686"/>
                      </svg>
                    </div>,
                    props.selectedUsers.length != index + 1 && (
                      <div className="user-separator m-t-12 m-b-12"/>
                    )
                  ]
                })
              }
            </div>
          </div>
          <div onClick={()=>handleEnqConvertToMember()} className="bottom-action-button">
            <div className={`member-button-global btn-center  d-flex ${isButtonLock ? "member-button-global-inactive" : "global-blue-button-controller-active"}`} style={{ width: "100%", height:"40px", borderRadius:"20px" }}>
              <p className="flex-item">Confirm</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConvertToMember;